import type { Locale } from 'date-fns';
import { fr } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

/**
 * The date-fns locale to pass to `format()`'s `locale` option so month/weekday
 * names render in the current language — date-fns defaults to English otherwise.
 */
export default function useDateLocale(): Locale | undefined {
  const { i18n } = useTranslation();

  return i18n.language === 'fr' ? fr : undefined;
}
